import { render, staticRenderFns } from "./SchoolManagementPage.vue?vue&type=template&id=5e90574f&scoped=true&"
import script from "./SchoolManagementPage.vue?vue&type=script&lang=js&"
export * from "./SchoolManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e90574f",
  null
  
)

export default component.exports